import { render, staticRenderFns } from "./VacancyQuestionsLibraryTextList.vue?vue&type=template&id=5f1483b1&scoped=true&"
import script from "./VacancyQuestionsLibraryTextList.vue?vue&type=script&lang=js&"
export * from "./VacancyQuestionsLibraryTextList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1483b1",
  null
  
)

export default component.exports